/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */	
import StripAnimation from './StripAnimation';

const PoisonWeaponEffect = function( duration ) {
	return new StripAnimation( 
		'effects/poison_weapon',
		duration,
		12,
		false
	);	
}
export default PoisonWeaponEffect;